<template>
  <main class="promo-main">
    <header class="promo-toolbar">
      <div class="toolbar-left">
        <span class="title">裂变结果</span>
      </div>
      <div class="toolbar-actions">
        <button
          class="download-btn"
          :disabled="!hasResults"
          @click="workbench.downloadAllFission"
        >
          <img class="download-icon" src="/download.svg" alt="" />
          <span>下载全部 ({{ validResultsCount }})</span>
        </button>
      </div>
    </header>

    <section class="promo-gallery">
      <div class="gallery-grid">
        <FissionGalleryCard
          v-for="(item, index) in workbench.fission.items"
          :key="index"
          :item="item"
          :index="index"
        />

        <div v-if="!workbench.fission.items.length" class="fission-empty-state">
          请先在“宣传图生成”工作台勾选图片，然后点击“将所选图片用于裂变”
        </div>
      </div>
    </section>
  </main>
</template>

<script setup>
import { computed } from "vue";
import FissionGalleryCard from "./FissionGalleryCard.vue";
import { useWorkbenchStore } from "@/stores/useWorkbenchStore";

const workbench = useWorkbenchStore();

// 计算是否有成功生成的图片
const validResultsCount = computed(() => {
  return workbench.fission.items.filter((item) => item.resultUrl).length;
});
const hasResults = computed(() => validResultsCount.value > 0);
</script>
